module.exports = __webpack_public_path__ + "img/festival-galo.e93076e8.png";